/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $UpdateApprovalCompetencyRequest = {
  properties: {
    id: {
      type: 'string',
      isRequired: true,
    },
    name: {
      type: 'string',
    },
    min: {
      type: 'number',
    },
    max: {
      type: 'number',
    },
  },
} as const;
